import * as React from "react";
import type { SVGProps } from "react";
const SvgWeChatBot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={140}
    height={140}
    fill="none"
    {...props}
  >
    <path
      fill="url(#we-chat-bot_svg__a)"
      d="M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M25 67.156V39.264a1.844 1.844 0 0 1 3.688 0v12.775c5.201-9.99 15.406-16.995 27.39-17.617l4.422-.23 4.422.23c11.984.622 22.189 7.627 27.39 17.617V39.263a1.844 1.844 0 1 1 3.688 0v35.27c0 6.57-10.604 11.526-35.5 11.526S25 81.103 25 74.533zM42.059 54.94a9.22 9.22 0 1 0 0 18.441h36.883a9.22 9.22 0 0 0 0-18.441z"
      clipRule="evenodd"
    />
    <circle cx={42.059} cy={64.159} r={4.61} fill="#fff" />
    <circle cx={78.941} cy={64.159} r={4.61} fill="#fff" />
    <g filter="url(#we-chat-bot_svg__b)">
      <path
        fill="url(#we-chat-bot_svg__c)"
        d="M100 128c15.464 0 28-12.536 28-28s-12.536-28-28-28-28 12.536-28 28 12.536 28 28 28"
      />
      <path
        fill="url(#we-chat-bot_svg__d)"
        d="M100 128c15.464 0 28-12.536 28-28s-12.536-28-28-28-28 12.536-28 28 12.536 28 28 28"
      />
      <path
        stroke="#fff"
        strokeWidth={4}
        d="M100 130c16.569 0 30-13.431 30-30 0-16.568-13.431-30-30-30-16.568 0-30 13.432-30 30 0 16.569 13.432 30 30 30Z"
      />
    </g>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M122.229 104.871c0-6.07-5.807-10.983-12.969-10.983S96.292 98.8 96.292 104.87c0 6.05 5.806 10.962 12.968 10.984a15.9 15.9 0 0 0 4.254-.633c.099-.027.091-.026.352-.079.261-.052.488.079.685.184l2.801 1.69c.129.07.206.105.312.105.227 0 .42-.196.415-.422.005-.125-.035-.224-.065-.329a57 57 0 0 1-.558-2.206 1.5 1.5 0 0 1-.039-.399c0-.218.11-.452.351-.657 2.713-1.966 4.461-4.943 4.461-8.238m-17.377-1.901c-.866 0-1.61-.756-1.61-1.74 0-.883.744-1.64 1.61-1.64.968 0 1.71.758 1.71 1.64 0 .984-.742 1.74-1.71 1.74m8.611 0c-.866 0-1.61-.756-1.61-1.74 0-.883.744-1.64 1.61-1.64.967 0 1.71.758 1.71 1.64 0 .984-.743 1.74-1.71 1.74"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M79 95.048c0 3.888 2.087 7.418 5.375 9.812.242.18.37.386.37.732 0 .119-.02.248-.06.416-.276 1.136-.577 2.436-.62 2.61s-.113.29-.104.418a.51.51 0 0 0 .517.522c.103 0 .195-.043.31-.105l3.41-1.983c.216-.132.459-.2.622-.2.164 0 .437.051.619.096 1.581.407 3.288.663 5.064.626q.414.05.827 0a10.8 10.8 0 0 1-.517-3.132c.013-6.596 6.34-11.91 14.16-11.9.268-.01.548-.002.827 0C108.632 86.756 102.226 82 94.503 82 85.938 82 79 87.828 79 95.048m10.232-2.088a2.05 2.05 0 0 1-1.462-.61 2.1 2.1 0 0 1-.605-1.477 2.1 2.1 0 0 1 .605-1.476 2.07 2.07 0 0 1 1.462-.612 2.05 2.05 0 0 1 1.462.612 2.1 2.1 0 0 1 .605 1.476 2.1 2.1 0 0 1-.605 1.476 2.07 2.07 0 0 1-1.462.611m10.336 0a2.05 2.05 0 0 1-1.462-.61 2.1 2.1 0 0 1-.605-1.477 2.1 2.1 0 0 1 .605-1.476 2.07 2.07 0 0 1 1.462-.612 2.06 2.06 0 0 1 1.442.622 2.1 2.1 0 0 1 0 2.931c-.381.391-.899.615-1.442.623"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="we-chat-bot_svg__a"
        x1={60.001}
        x2={60.001}
        y1={0.326}
        y2={120.002}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#02E36F" />
        <stop offset={1} stopColor="#07C160" />
      </linearGradient>
      <linearGradient
        id="we-chat-bot_svg__c"
        x1={109.352}
        x2={95.352}
        y1={81.352}
        y2={114}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37AEE2" />
        <stop offset={1} stopColor="#1E96C8" />
      </linearGradient>
      <linearGradient
        id="we-chat-bot_svg__d"
        x1={100}
        x2={100}
        y1={72.152}
        y2={128.001}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#02E36F" />
        <stop offset={1} stopColor="#07C160" />
      </linearGradient>
      <filter
        id="we-chat-bot_svg__b"
        width={88}
        height={88}
        x={56}
        y={56}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={6} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_302_1733"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_302_1733"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgWeChatBot;
